import axios from "axios";
import "./api_helper";
import { api } from "../config";

const BASE = api.API_URL;

export const getCmiEmpresas = () => axios.get(`${BASE}/config/empresas`);
export const getCmiEmpresa = (id) => axios.get(`${BASE}/config/empresas/${id}`);
export const createCmiEmpresa = (data) => axios.post(`${BASE}/config/empresas`, data);
export const updateCmiEmpresa = (id, data) => axios.put(`${BASE}/config/empresas/${id}`, data);
export const deleteCmiEmpresa = (id) => axios.delete(`${BASE}/config/empresas/${id}`);
export const reorderCmiEmpresas = (orden) => axios.put(`${BASE}/config/empresas-orden`, { orden });
export const getErpEmpresas = () => axios.get(`${BASE}/config/erp/empresas`);

// Presupuestos
export const getPresupuestosPorEmpresa = (ejercicio) => axios.get(`${BASE}/config/presupuestos`, { params: { ejercicio } });
export const getPresupuesto = (id) => axios.get(`${BASE}/config/presupuestos/${id}`);
export const createPresupuesto = (data) => axios.post(`${BASE}/config/presupuestos`, data);
export const updatePresupuesto = (id, data) => axios.put(`${BASE}/config/presupuestos/${id}`, data);
export const savePresupuestoDetalle = (id, detalle) => axios.put(`${BASE}/config/presupuestos/${id}/detalle`, { detalle });

export const deletePresupuesto = (id) => axios.delete(`${BASE}/config/presupuestos/${id}`);

// Cuentas contables
export const getCuentasContables = (empresaId, tipo) => axios.get(`${BASE}/config/cuentas`, { params: { empresa_id: empresaId, tipo } });
export const getCategoriasCuentas = () => axios.get(`${BASE}/config/cuentas/categorias`);
export const clasificarCuenta = (data) => axios.post(`${BASE}/config/cuentas/clasificar`, data);
export const desclasificarCuenta = (empresa_id, numero_cuenta) => axios.post(`${BASE}/config/cuentas/desclasificar`, { empresa_id, numero_cuenta });
export const syncCuentasHolded = (empresaId, year) => axios.post(`${BASE}/finanzas/v2/sync/cuentas`, {}, { params: { empresa_id: empresaId, year } });

// Empleados
export const getEmpleados = (empresaId) => axios.get(`${BASE}/config/empleados`, { params: { empresa_id: empresaId } });
export const vincularEmpleado = (data) => axios.post(`${BASE}/config/empleados`, data);
export const actualizarEmpleado = (id, data) => axios.put(`${BASE}/config/empleados/${id}`, data);
export const toggleEmpleado = (id) => axios.patch(`${BASE}/config/empleados/${id}/toggle`);
export const deleteEmpleado = (id) => axios.delete(`${BASE}/config/empleados/${id}`);
export const getCategoriasEmpleados = () => axios.get(`${BASE}/config/empleados/categorias`);
export const saveCategoriasEmpleados = (data) => axios.post(`${BASE}/config/empleados/categorias`, data);
export const getUsuariosErp = () => axios.get(`${BASE}/config/empleados/usuarios-erp`);
export const getKronalyEmpleados = (empresaId) => axios.get(`${BASE}/config/empleados/kronaly`, { params: { empresa_id: empresaId } });

// Benchmarks
export const getBenchmarks = (ejercicio) => axios.get(`${BASE}/config/benchmarks`, { params: { ejercicio } });
export const saveBenchmarks = (ejercicio, benchmarks) => axios.post(`${BASE}/config/benchmarks`, { ejercicio, benchmarks });
